// AUTO-GENERATED FILE - DO NOT EDIT
// Generated by scripts/generate-cube-meta.ts
import type {
  CubeMeasureEntry,
  CubeDimensionEntry,
  CubeJoinEntry
} from 'shared/src/api/cube-api-types';

export const insertionOrdersCubeMeta = {
  name: 'insertion_orders',
  sqlTable: 'media_tool.insertion_orders',
  title: 'Insertion Orders',
  joins: {
    campaigns: { relationship: 'many_to_one' } as const satisfies CubeJoinEntry
  },
  measures: {
    'insertion_orders.count': {
      type: 'number',
      aggType: 'count',
      title: 'Insertion Order Count',
      description: 'Number of insertion orders',
      meta: {
        category: 'utility',
        supports_rollup: true,
        formula: 'COUNT(*)',
        inputs: [],
        short_description: 'Number of insertion orders',
        source_tables: ['media_tool.insertion_orders']
      }
    } as const satisfies CubeMeasureEntry
  },
  dimensions: {
    'insertion_orders.id': {
      sql: 'id',
      type: 'string',
      title: 'Insertion Order ID',
      primaryKey: true,
      meta: {
        short_description: 'Zoho CRM Insertion Order ID',
        source_tables: ['media_tool.insertion_orders']
      }
    } as const satisfies CubeDimensionEntry,
    'insertion_orders.name': {
      sql: 'name',
      type: 'string',
      title: 'Insertion Order Name',
      meta: {
        short_description: 'Insertion order display name',
        source_tables: ['media_tool.insertion_orders']
      }
    } as const satisfies CubeDimensionEntry,
    'insertion_orders.io_type': {
      sql: 'io_type',
      type: 'string',
      title: 'IO Type',
      meta: {
        short_description: 'Insertion order type classification',
        source_tables: ['media_tool.insertion_orders']
      }
    } as const satisfies CubeDimensionEntry,
    'insertion_orders.io_number': {
      sql: 'io_number',
      type: 'string',
      title: 'IO Number',
      meta: {
        short_description: 'Insertion order number',
        source_tables: ['media_tool.insertion_orders']
      }
    } as const satisfies CubeDimensionEntry,
    'insertion_orders.total': {
      sql: 'total',
      type: 'number',
      title: 'Total',
      format: 'currency',
      meta: {
        category: 'financial',
        short_description: 'Insertion order total amount',
        source_tables: ['media_tool.insertion_orders']
      }
    } as const satisfies CubeDimensionEntry,
    'insertion_orders.grand_total': {
      sql: 'grand_total',
      type: 'number',
      title: 'Grand Total',
      format: 'currency',
      meta: {
        category: 'financial',
        short_description: 'Insertion order grand total amount',
        source_tables: ['media_tool.insertion_orders']
      }
    } as const satisfies CubeDimensionEntry,
    'insertion_orders.pia_discount_amount': {
      sql: 'pia_discount_amount',
      type: 'number',
      title: 'PIA Discount Amount',
      format: 'currency',
      meta: {
        category: 'financial',
        short_description: 'PIA discount amount applied to the IO',
        source_tables: ['media_tool.insertion_orders']
      }
    } as const satisfies CubeDimensionEntry,
    'insertion_orders.gross_budget': {
      sql: 'gross_budget',
      type: 'number',
      title: 'Gross Budget',
      format: 'currency',
      meta: {
        category: 'financial',
        short_description: 'Gross budget amount for the IO',
        source_tables: ['media_tool.insertion_orders']
      }
    } as const satisfies CubeDimensionEntry,
    'insertion_orders.campaign_start_date': {
      sql: 'campaign_start_date',
      type: 'time',
      title: 'Campaign Start Date',
      meta: {
        short_description: 'Campaign start date on the IO',
        source_tables: ['media_tool.insertion_orders']
      }
    } as const satisfies CubeDimensionEntry,
    'insertion_orders.campaign_end_date': {
      sql: 'campaign_end_date',
      type: 'time',
      title: 'Campaign End Date',
      meta: {
        short_description: 'Campaign end date on the IO',
        source_tables: ['media_tool.insertion_orders']
      }
    } as const satisfies CubeDimensionEntry,
    'insertion_orders.geo': {
      sql: 'geo',
      type: 'string',
      title: 'Geo',
      meta: {
        short_description: 'Geographic targeting for the IO',
        source_tables: ['media_tool.insertion_orders']
      }
    } as const satisfies CubeDimensionEntry,
    'insertion_orders.audience': {
      sql: 'audience',
      type: 'string',
      title: 'Audience',
      meta: {
        short_description: 'Target audience for the IO',
        source_tables: ['media_tool.insertion_orders']
      }
    } as const satisfies CubeDimensionEntry,
    'insertion_orders.package': {
      sql: 'package',
      type: 'string',
      title: 'Package',
      meta: {
        short_description: 'Package type for the IO',
        source_tables: ['media_tool.insertion_orders']
      }
    } as const satisfies CubeDimensionEntry,
    'insertion_orders.number_of_months': {
      sql: 'number_of_months',
      type: 'string',
      title: 'Number of Months',
      meta: {
        short_description: 'Duration in months for the IO',
        source_tables: ['media_tool.insertion_orders']
      }
    } as const satisfies CubeDimensionEntry,
    'insertion_orders.client': {
      sql: 'client',
      type: 'string',
      title: 'Client',
      meta: {
        short_description: 'Client name on the IO',
        source_tables: ['media_tool.insertion_orders']
      }
    } as const satisfies CubeDimensionEntry,
    'insertion_orders.agency': {
      sql: 'agency',
      type: 'string',
      title: 'Agency',
      meta: {
        short_description: 'Agency name on the IO',
        source_tables: ['media_tool.insertion_orders']
      }
    } as const satisfies CubeDimensionEntry,
    'insertion_orders.sales_rep': {
      sql: 'sales_rep',
      type: 'string',
      title: 'Sales Rep',
      meta: {
        short_description: 'Sales representative assigned to the IO',
        source_tables: ['media_tool.insertion_orders']
      }
    } as const satisfies CubeDimensionEntry,
    'insertion_orders.mc': {
      sql: 'mc',
      type: 'string',
      title: 'MC',
      meta: {
        short_description: 'Media campaign ID (Zoho CRM Deal ID) linking IO to a campaign',
        source_tables: ['media_tool.insertion_orders']
      }
    } as const satisfies CubeDimensionEntry,
    'insertion_orders.media_campaign_number': {
      sql: 'media_campaign_number',
      type: 'string',
      title: 'Media Campaign Number',
      meta: {
        short_description: 'Campaign number linking IO to a campaign',
        source_tables: ['media_tool.insertion_orders']
      }
    } as const satisfies CubeDimensionEntry,
    'insertion_orders.modified_time': {
      sql: 'modified_time',
      type: 'time',
      title: 'Modified Time',
      meta: {
        short_description: 'Last modified timestamp from Zoho CRM',
        source_tables: ['media_tool.insertion_orders']
      }
    } as const satisfies CubeDimensionEntry,
    'insertion_orders.sign_status': {
      sql: "COALESCE((SELECT CASE WHEN zd.zohosign_document_status IN ('Completed', 'Signed') THEN 'completed' WHEN zd.zohosign_document_status = 'Declined' THEN 'declined' WHEN zd.zohosign_document_status = 'Recalled' THEN 'recalled' WHEN zd.zohosign_document_status = 'Expired' THEN 'expired' WHEN zd.zohosign_document_status = 'Out for Signature' THEN 'out_for_signature' ELSE 'created' END FROM media_tool.zohosign_documents zd WHERE zd.insertion_order = insertion_orders.id ORDER BY zd.created_time DESC NULLS LAST LIMIT 1 ), 'no_document')",
      type: 'string',
      title: 'Sign Status',
      meta: {
        short_description:
          'ZohoSign document status for this IO: completed, declined, recalled, expired, out_for_signature, no_document, or created',
        source_tables: ['media_tool.insertion_orders', 'media_tool.zohosign_documents']
      }
    } as const satisfies CubeDimensionEntry,
    'insertion_orders.has_signed_document': {
      sql: "EXISTS (SELECT 1 FROM media_tool.zohosign_documents zd WHERE zd.insertion_order = insertion_orders.id AND zd.zohosign_document_status IN ('Completed', 'Signed'))",
      type: 'boolean',
      title: 'Has Signed Document',
      meta: {
        short_description: 'Whether this IO has a completed/signed ZohoSign document',
        source_tables: ['media_tool.insertion_orders', 'media_tool.zohosign_documents']
      }
    } as const satisfies CubeDimensionEntry
  }
};
